import { create } from "../../../common/utils/zustand_state_manager";
import { IncorporacaoService } from "../../../features/incorporacao/data/services/incorporacao_service_impl";

/**
 * useIncorporacaoServices
 */

type State = {
  incorporacaoService: IncorporacaoService,
};

export const useIncorporacaoServices = create<State>((set, get) => ({
  incorporacaoService: new IncorporacaoService(),
}));